// Where a file menu's project opens (`AssetMenu`'s last item): the Library page, unless the page
// that draws the Library's content says otherwise. Pro's Library files draw that content inside
// Pro's frame and open a project there (spec ui-perf/ui-switch-classic-simple-pro, PR e3).
import { createContext, useContext, type ReactNode } from "react";

/** Renders a project's link, as `renderRoot` takes it, for the folder `folderId`. */
export type ProjectLink = (props: Record<string, unknown>, folderId: string) => ReactNode;

const ProjectLinkContext = createContext<ProjectLink | null>(null);

/** Opens every project under it with `link` instead of on the Library page. */
export function ProjectLinkProvider({ link, children }: { link: ProjectLink; children: ReactNode }) {
  return <ProjectLinkContext.Provider value={link}>{children}</ProjectLinkContext.Provider>;
}

/** The project link a page set, or `null` for the Library page's. */
export function useProjectLink(): ProjectLink | null {
  return useContext(ProjectLinkContext);
}
